"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProperty = exports.isPropertyName = exports.supportedProviders = exports.supportedPropertyNames = exports.supportedPropertyTypeNames = void 0;
const shared_1 = require("@rb3ea-backend/shared");
exports.supportedPropertyTypeNames = [
    'asset',
    'boolean',
    'child-ref',
    'container',
    'custom',
    'date',
    'date-time',
    'duration',
    'geodata',
    'int',
    'mime:image',
    'one-of-container',
    'ordered-container',
    'select',
    'service',
    'table',
    'text',
    'rich-text',
];
exports.supportedPropertyNames = [
    'accordion-block-content',
    'accordion-block-title',
    'accordion-block',
    'accordion-blocks',
    'accordion-title',
    'accordion',
    'alternative-labels',
    'associated-assets',
    'audio-essence',
    'audio',
    'authorship',
    'authorship-author',
    'authorship-link',
    'backdrop-media',
    'bio',
    'bg-hex-color-code',
    'branding-hex-color-code',
    'broader-collection',
    'broader-content-category',
    'broader-discipline',
    'broader-playground',
    'car',
    'career-start',
    'city',
    'clip-essence',
    'content-categories',
    'content-classification-terms',
    'continent',
    'country-code',
    'country-name',
    'couple-left-image',
    'couple-right-image-or-quote',
    'couple-right-image',
    'couple',
    'credits',
    'crew-member',
    'cta-action-type',
    'cta-anchor-attached-paragraph',
    'cta-anchor',
    'cta-asset-link',
    'cta-asset',
    'cta-button-label',
    'cta-container',
    'cta-end-date',
    'cta-start-date',
    'cta-story-content-container',
    'cta-story-content-container-wrapper',
    'cta-ticket',
    'cta-ticket-service',
    'cta-url-link',
    'cta-url',
    'date-of-birth',
    'date-of-death',
    'description',
    'disciplines',
    'driver-type',
    'editorial-publish-date',
    'editorial-type',
    'embedded-content-asset',
    'embedded-content-title',
    'embedded-content',
    'epg-description',
    'epg-title',
    'episode-number',
    'episode-video-ref',
    'event-end-date',
    'event-profile',
    'event-ref',
    'event-results',
    'event-season',
    'event-start-date',
    'event-status-message',
    'event-status',
    'exclude-content-tagged-with',
    'excluded-tags',
    'extra-for',
    'fact-content-container',
    'fact-content-label',
    'fact-content-text',
    'fact-content',
    'fact-display-sidefact',
    'fact-title',
    'fact',
    'featured-media',
    'featured-title',
    'featured-video',
    'first-name',
    'flavour',
    'frequency-cap',
    'gender',
    'geodata',
    'geolocation',
    'header-media',
    'headline-chapter',
    'headline-text',
    'headline',
    'height',
    'hosted-by-red-bull',
    'hosts',
    'image-caption-flag',
    'image-essence',
    'image-gallery',
    'image',
    'images',
    'immersive-3d-model-essence',
    'include-content-tagged-with',
    'info-block-description',
    'info-block-group-info-blocks',
    'info-block-group-title',
    'info-block-group',
    'info-block-image',
    'info-block-label',
    'info-block-title',
    'info-block-url-link',
    'info-block-url-text',
    'info-block-url',
    'info-block',
    'interview-answer-author',
    'interview-answer-link',
    'interview-answer-text',
    'interview-answer',
    'interview-answers',
    'interview-question',
    'interview',
    'is-currently-active',
    'key-visual',
    'label',
    'language',
    'legal-disclaimer',
    'linear-stream',
    'list',
    'live-videos',
    'livestream-end-date',
    'livestream-start-date',
    'local-brand-name',
    'location-of-nationality',
    'location',
    'logos',
    'main-partner-asset',
    'main-partner-caption',
    'mediabase-essence',
    'no-embedding',
    'no-monetization',
    'numbered-list',
    'packshot',
    'participated-years',
    'participating-disciplines',
    'partner-hosted-livestream-container',
    'partner-hosted-livestream-cta-container',
    'partner-hosted-livestream-cta-url',
    'partner-hosted-livestream-post-stream-exclusive-timespan',
    'partner-hosted-livestream-streaming-partner',
    'partner-hosted-livestream-target-country-code',
    'partner-hosted-livestream',
    'partner-icon',
    'partner-profiles',
    'place-of-birth',
    'playability-start-date',
    'playground',
    'playground-project',
    'podcast-episode-ref',
    'podcast-essence',
    'podcast-preview',
    'podcast-season',
    'podcast-season-ref',
    'podcast-show',
    'preferred-label',
    'product-related-image',
    'product-related-quote',
    'promo-type',
    'properties-container',
    'property-name',
    'property-value',
    'property',
    'quick-event',
    'quote-author',
    'quote-link',
    'quote-text',
    'quote',
    'record-description',
    'record-discipline',
    'record',
    'redbulltv-livestream',
    'related-content',
    'results-and-standings',
    'results-table-additional',
    'results-table-cell-value-asset',
    'results-table-cell-value-float',
    'results-table-cell-value-integer',
    'results-table-cell-value-percent',
    'results-table-cell-value-person',
    'results-table-cell-value-points',
    'results-table-cell-value-rank',
    'results-table-cell-value-text',
    'results-table-cell-value-timestamp',
    'results-table-column-additional',
    'results-table-column-format-hint',
    'results-table-column-main-result',
    'results-table-column-name',
    'results-table-column-person',
    'results-table-column-pinned',
    'results-table-column-rank',
    'results-table-column-title',
    'results-table-columns-additional',
    'results-table-columns',
    'results-table-row-cell-additional',
    'results-table-row-cell-main-result',
    'results-table-row-cell-person',
    'results-table-row-cell-rank',
    'results-table-row-cells-additional',
    'results-table-row',
    'results-table-rows',
    'results-table-title',
    'results-table',
    'search-terms',
    'season-number',
    'season-ref',
    'season',
    'seo-filename',
    'seo-title',
    'series-end-date',
    'series-start-date',
    'series',
    'service-embed',
    'show',
    'social-links',
    'social-media-image',
    'social-title',
    'social-wall',
    'soft-facts',
    'sound-bite',
    'sponsored-by',
    'standalone',
    'state',
    'statement',
    'story-content',
    'start-date',
    'subheading',
    'subpage-asset',
    'subpage-label',
    'subpage',
    'subpages-container',
    'surname',
    'table',
    'tag-event-series',
    'tag-events',
    'tag-judges',
    'tag-persons',
    'tag-photographers',
    'tag-rally-drivers',
    'tag-rally-teams',
    'tag-status',
    'tag-teams',
    'target-tags',
    'team-leader',
    'team-quote-author',
    'team-quote-link',
    'team-quote-text',
    'team-quote',
    'teaser',
    'text',
    'tip-content-author',
    'tip-content-container',
    'tip-content-link',
    'tip-content-text',
    'tip-content',
    'tip-display-sidefact',
    'tip-title',
    'tip',
    'title',
    'track-record',
    'track-records',
    'transcript',
    'type-of-collection',
    'type-of-content-collection',
    'type-of-editorial-list',
    'type-of-image',
    'type-of-playground',
    'uri-title',
    'url',
    'variant',
    'venue',
    'video-essence',
    'video-marker-link-asset',
    'video-marker-link-external-link',
    'video-marker-link',
    'video-marker-timestamp',
    'video-marker-title',
    'video-marker',
    'video-markers',
    'video',
    'vr-360',
    'website',
    'weight',
    'year',
    'zoe-embed',
];
exports.supportedProviders = [
    'Instagram',
    'Eventbrite',
    'Facebook',
    'Pixlee',
    'RBMN Audio',
    'ScribbleLive',
    'Snapchat',
    'SoundCloud',
    'Spotify',
    'Twitch',
    'TikTok',
    'Twitter',
    'YouTube',
    'RBMN Video',
];
const isPropertyName = (name) => exports.supportedPropertyNames.includes(name);
exports.isPropertyName = isPropertyName;
const isProperty = (property) => {
    const propertyCast = property;
    return (0, shared_1.isDefined)(propertyCast.name)
        && (0, shared_1.isDefined)(propertyCast.constraints)
        && (0, shared_1.isDefined)(propertyCast.view)
        && (0, shared_1.isDefined)(propertyCast.multiple)
        && (0, shared_1.isDefined)(propertyCast.type);
};
exports.isProperty = isProperty;
//# sourceMappingURL=data:application/json;base64,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